// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"81cb4a52","198":"a0c555af","199":"a7ea030c","391":"da1b9d61","498":"dbe7f229","876":"b676a3b7"}[chunkId] + ".chunk.js";
};